export const USER_PROFILE = 'user-profile';
export const LANDING_PAGE_CONFIG = 'landing-page-config';
export const R1_NETWORK = 'r1-network';
export const COUNTRY_NETWORK = 'country-network';
export const DISCONTINUED_REFERENCES = 'discontinued-references';
export const BAM_COMMERCIAL_FAMILY_CODES = 'bam-commercial-family-codes';
export const PROMOTION = 'promotion';
export const ELECTRONIC_PARTS_REPAIR = 'electronic-parts-repair';
export const CROSS_SELLING = 'cross-selling';
export const DELIVERY_LEAD_TIME = 'delivery-lead-time';
export const ASSISTANCE_COUNTRY = 'assistance-country';
export const ASSISTANCE_CENTRAL = 'assistance-central';
export const LIBRARY = 'library';
export const INFORMATION = 'information';
export const NOTIFICATION_CENTER = 'notification-center';
export const CENTRAL_SETTINGS = 'central-settings';
export const SEARCH_RATE_LIMIT = 'search-rate-limit';
export const CREATE_NEW = 'create-new';
export const EDIT = 'edit';
export const COPY = 'copy';
export const DETAILS = 'details';

export const CREATE_NEW_TEMPLATE = 'create-new-template';
export const EDIT_TEMPLATE = 'edit-template';
